/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useMemo } from 'react';
import type { FilterDataType, HandleFilterType } from '../types/filterTypes';
import { getVisualFilters } from '@/components/Filter/utils/getVisualFilters';
import { type VisualFilterModel } from '@/api/types/browse-search-types';

export const useVisualFilters = (
  visualFilters: VisualFilterModel[],
  staticFilterData: FilterDataType[]
): HandleFilterType[] => {
  const visualFiltersSet = useMemo(
    () =>
      staticFilterData?.flatMap((filter: FilterDataType) => {
        return getVisualFilters({ visualFilters, filter });
      }) ?? [],
    [visualFilters, staticFilterData]
  );

  return visualFiltersSet;
};
